import apiClient from '@/services/api-client';

export const getOrders = async (params) => {
    try {
        const response = await apiClient.get('/order/list', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching orders:', error);
        throw error;
    }
};


export const getOrdersStatus = async () => {
    try {
        const response = await apiClient.get('/order/order-status-stats');
        return response.data;
    } catch (error) {
        console.error('Error fetching orders:', error);
        throw error;
    }
};

/* ----------------- Draft Order ----------------- */

export const deleteOrder = async (params) => {
    try {
        const response = await apiClient.get('/order/delete' , {params});
        return response.data;
    } catch (error) {
        console.error('Error delete draft order:', error);
        throw error;
    }
};


export const addDraftOrder = async () => {
    try {
        const response = await apiClient.post('/order/add');
        return response.data;
    } catch (error) {
        console.error('Error creating draft order:', error);
        throw error;
    }
};

export const getOrderBySpecialRef = async (specialRef) => {
    try {
        const response = await apiClient.get('/order/get/special-ref', {
            params: { specialRef }
        });
        return response.data; // OrderResponseDTO
    } catch (error) {
        console.error(`Error fetching order ${specialRef}:`, error);
        throw error;
    }
};

/* ----------------- Order Lines ----------------- */

export const addOrderLine = async (specialRef, item) => {
    try {
        const response = await apiClient.post('/order/add/order-line', item, {
            params: { specialRef }
        });
        return response.data; // updated OrderResponseDTO
    } catch (error) {
        console.error(`Error adding order line to ${specialRef}:`, error);
        throw error;
    }
};

/* ----------------- Set Customer ----------------- */

// Assign a customer to a draft order
export const setOrderCustomer = async (specialRef, customerId) => {
    try {
        const response = await apiClient.post('/order/set-customer', null, {
            params: { specialRef, customerId }
        });
        return response.data; // updated OrderResponseDTO
    } catch (error) {
        console.error(`Error setting customer for order ${specialRef}:`, error);
        throw error;
    }
};


export const removeOrderLine = async (specialRef, orderLineId) => {
    try {
        const response = await apiClient.post('/order/remove/order-line', null, {
            params: { specialRef, orderLineId }
        });
        return response.data; // updated OrderResponseDTO
    } catch (error) {
        console.error(`Error removing order line ${orderLineId} from order ${specialRef}:`, error);
        throw error;
    }
};


export const addTaxes = async (specialRef, taxStamp) => {
    try {
        const response = await apiClient.post('/order/add/taxes', null, {
            params: { specialRef, taxStamp }
        });
        return response.data;
    } catch (error) {
        console.error(`Error adding taxes to order ${specialRef}:`, error);
        throw error;
    }
};

/* ---------------- Submit Order ---------------- */

export const submitQuote = async (specialRef, note, projectName) => {
    try {
        const response = await apiClient.post('/order/submit', null, {
            params: { specialRef, note,projectName }
        });
        return response.data;
    } catch (error) {
        console.error('Error submitting order:', error);
        throw error;
    }
};


export const downloadOrderFile = async (orderId) => {
  try {
    const response = await apiClient.get('/order/generate', {
      params: { orderId },
      responseType: 'blob'
    });

    const pdfBlob = new Blob([response.data], {
      type: 'application/pdf'
    });

    const pdfUrl = window.URL.createObjectURL(pdfBlob);

    window.open(pdfUrl, '_blank');

    setTimeout(() => {
      window.URL.revokeObjectURL(pdfUrl);
    }, 10000);

  } catch (error) {
    console.error('Error downloading invoice:', error);
    throw error;
  }
};

